
import React from 'react';
import { User, PlusCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogTrigger } from '@/components/ui/dialog';
import AddChildForm from './AddChildForm';

interface EmptyChildrenStateProps {
  onAddChild: (child: { name: string; birthdate: string; photoUrl?: string }) => Promise<void>;
}

const EmptyChildrenState: React.FC<EmptyChildrenStateProps> = ({ onAddChild }) => {
  return (
    <div className="text-center py-12 border border-dashed rounded-lg">
      <User className="h-12 w-12 mx-auto text-gray-400 mb-4" />
      <h3 className="text-lg font-medium mb-2">No Children Added Yet</h3>
      <p className="text-muted-foreground mb-6">
        Add your first child to start recording their memorable quotes.
      </p>
      <Dialog>
        <DialogTrigger asChild>
          <Button>
            <PlusCircle className="h-4 w-4 mr-2" />
            Add Child
          </Button>
        </DialogTrigger>
        <AddChildForm onAddChild={onAddChild} />
      </Dialog>
    </div>
  );
};

export default EmptyChildrenState;
